import { RequireSubmissionProvided } from "../../../wrappers/requireSubmission";
import { SubmitToChm2026 } from "./submitToCHM/2026/submitToChm2026";

interface SubmitToCHMProps extends RequireSubmissionProvided {
}

/**
 * The CHM submission flow, for both initial submissions and add-ons.
 *
 * The 2023 and 2024 flows were resume-only paths for submissions started under an older plan
 * year; they have been retired and their stored `data` payloads normalized to the 2026 shape
 * (see supabase/migrations/20260823000000_normalize_legacy_submission_data.sql), so every
 * submission now renders the 2026 flow regardless of what `data` holds.
 */
export function SubmitToCHM({ submission }: SubmitToCHMProps) {
  return <SubmitToChm2026 submission={submission} />
}
